<template>
  <div class="spinner" :class="{'fullScreen': fullScreen}">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    fullScreen: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.spinner {
  min-height: 50px;
  height: 100%;
}
.fullScreen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue